import * as React from "react";
import { Card } from "react-bootstrap";
import AppRoutes from "./AppRoutes";
import { PublicPageContainer } from "./components/ui/PublicPageContainer";
import { useAuth } from "./hooks/useAuth";

const iconErrorImg = require("img/ico-error.svg");

export function ErrorPage() {
    const { cloudAccount } = useAuth();
    return (
        <PublicPageContainer>
            <Card className="p-6 text-center">
                <div>
                    <img alt="Icon Error" src={iconErrorImg} width="128px" className="mb-4 img-responsive" />
                    <h1 className="mb-4">Something went wrong!</h1>
                    <p>That was unexpected. An error has occured and we&apos;re working to fix it soon.</p>
                    <p className="mb-4">more information.</p>
                    You can contact us at <a href="mailto:support@ravendb.net">support@ravendb.net</a> to get more
                    information.
                </div>
                <div>
                    <a
                        className="btn btn-primary btn-uppercase my-4"
                        href={
                            cloudAccount ? AppRoutes.forHome().link({ cloudAccount }) : AppRoutes.forHomePage().link()
                        }
                    >
                        Go to the Homepage
                    </a>
                </div>
            </Card>
        </PublicPageContainer>
    );
}
